import * as R from 'ramda';
import angular from 'angular';

export default function AssignRiskDialogController(
  $q,
  $rootScope,
  $scope,
  copy,
  ssDialogService,
  alerts,
  loaderService,
  assetDataService,
  riskDataService,
  riskSharedModelService,
  editRiskDialog,
) {
  const vm = this;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleEditAssetRiskSubmit = _handleEditAssetRiskSubmit;
  vm.handleAddRiskDialogClick = _handleAddRiskDialogClick;

  _activate();

  // //////// METHODS //////////
  function _activate() {
    $scope.$on('refreshRisks', () => {
      // if (data.masterVendorId === this.masterVendor.masterVendorId) {
      _refreshRisks();
      // }
    });

    getRiskList();
  }

  function _handleCloseDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.assetAdmin.assignRiskDialog);
  }

  function _handleEditAssetRiskSubmit() {
    if ($scope.assignRiskForm.$valid) {
      loaderService.showViewLoader = true;
      const riskIds = [];
      R.forEach(
        (item) => {
          if (item.isAssigned === true) {
            riskIds.push(item.customerRiskId);
          }
        },
        vm.savedRisks
      );
      if (riskIds.length === 0) {
        riskIds.push(-1);
      }
      assetDataService.saveAssetRisks(vm.asset.customerAssetId, riskIds.join()).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while saving the risk for asset.');
        } else {
          alerts.success('The risks for the asset have been saved successfully.');
          vm.saved = true;
          $rootScope.$broadcast('refreshAssetRisks', { asset: vm.asset });
          ssDialogService.hide(ssDialogService.dialogs.assetAdmin.assignRiskDialog);
        }
        loaderService.showViewLoader = false;
      });
    }
  }

  function _handleAddRiskDialogClick($event) {
    const risk = { customerRiskId: 0 };
    const promises = [
      riskDataService.getRiskDefaults(),
      getInitRiskAdmin(),
    ];
    return $q.all(promises).then((response) => {
      loaderService.showViewLoader = false;
      risk.riskOnset = response[0].data.riskOnset;
      risk.riskForewarning = response[0].data.riskForewarning;
      risk.riskDuration = response[0].data.riskDuration;
      risk.riskDataConfidentiality = response[0].data.riskDataConfidentiality;
      risk.riskDataIntegrity = response[0].data.riskDataIntegrity;
      risk.riskDataAvailability = response[0].data.riskDataAvailability;
      risk.riskDirection = response[0].data.riskDirection;
      risk.riskTrending = response[0].data.riskTrending;
      risk.riskAssessmentFrequency = response[0].data.riskAssessmentFrequency;
      risk.riskProbability = response[0].data.riskProbability;
      ssDialogService.dialogs.riskAdmin.editRiskDialog = ssDialogService.alert(
        editRiskDialog.getOptions($event, {
          risk,
          riskOnsets: riskSharedModelService.RiskOnsets,
          riskForewarnings: riskSharedModelService.RiskForewarnings,
          riskDurations: riskSharedModelService.RiskDurations,
          riskDataConfidentialities: riskSharedModelService.RiskDataConfidentialities,
          riskDataIntegrities: riskSharedModelService.RiskDataIntegrities,
          riskDataAvailabilities: riskSharedModelService.RiskDataAvailabilities,
          riskDirections: riskSharedModelService.RiskDirections,
          riskTrendings: riskSharedModelService.RiskTrendings,
          riskAssessmentFrequencies: riskSharedModelService.RiskAssessmentFrequencies,
          riskProbabilities: riskSharedModelService.RiskProbabilities,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.riskAdmin.editRiskDialog);
    });
  }

  function getInitRiskAdmin() {
    if (riskSharedModelService.RiskOnsets && riskSharedModelService.RiskOnsets.length > 0) {
      return Promise.resolve();
    }
    return riskDataService.initRiskAdmin().then((getRiskInitResponse) => {
      if (!getRiskInitResponse.data) {
        alerts.error('Error occurred get risk init data.');
      } else {
        if (getRiskInitResponse.data.RiskOnsets) {
          riskSharedModelService.RiskOnsets = getRiskInitResponse.data.RiskOnsets.result;
        }

        if (getRiskInitResponse.data.RiskForewarnings) {
          riskSharedModelService.RiskForewarnings = getRiskInitResponse.data.RiskForewarnings.result;
        }

        if (getRiskInitResponse.data.RiskDurations) {
          riskSharedModelService.RiskDurations = getRiskInitResponse.data.RiskDurations.result;
        }

        if (getRiskInitResponse.data.RiskDataConfidentialities) {
          riskSharedModelService.RiskDataConfidentialities = getRiskInitResponse.data.RiskDataConfidentialities.result;
        }


        if (getRiskInitResponse.data.RiskDataIntegrities) {
          riskSharedModelService.RiskDataIntegrities = getRiskInitResponse.data.RiskDataIntegrities.result;
        }

        if (getRiskInitResponse.data.RiskDataAvailabilities) {
          riskSharedModelService.RiskDataAvailabilities = getRiskInitResponse.data.RiskDataAvailabilities.result;
        }

        if (getRiskInitResponse.data.RiskDirections) {
          riskSharedModelService.RiskDirections = getRiskInitResponse.data.RiskDirections.result;
        }

        if (getRiskInitResponse.data.RiskTrendings) {
          riskSharedModelService.RiskTrendings = getRiskInitResponse.data.RiskTrendings.result;
        }

        if (getRiskInitResponse.data.RiskAssessmentFrequencies) {
          riskSharedModelService.RiskAssessmentFrequencies = getRiskInitResponse.data.RiskAssessmentFrequencies.result;
        }

        if (getRiskInitResponse.data.RiskProbabilities) {
          riskSharedModelService.RiskProbabilities = getRiskInitResponse.data.RiskProbabilities.result;
        }
      }
    });
  }


  function _refreshRisks() {
    return riskDataService.getRisks().then((results) => {
      vm.risks = results.data.result;
      getRiskList();
    });
  }

  function getRiskList() {
    const newRisks = angular.copy(vm.risks);
    vm.savedRisks = R.map((risk) => {
      risk.isAssigned = false;
      let isAssigned = false;
      if (vm.asset.customerAssetCustomerRisks && vm.asset.customerAssetCustomerRisks.length > 0) {
        isAssigned = R.find(
          R.propEq('customerRiskId', risk.customerRiskId),
          vm.asset.customerAssetCustomerRisks
        );
      }
      if (isAssigned) {
        risk.isAssigned = true;
      }
      return risk;
    }, newRisks);
  }
}

AssignRiskDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'copy',
  'ssDialogService',
  'alerts',
  'loaderService',
  'assetDataService',
  'riskDataService',
  'riskSharedModelService',
  'editRiskDialog',
];
